// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ICertificationSchemaApi,
  ICertificationSchemaApiRequest,
  ICertificationSchemaApiGetAllAttrs,
  ICertificationSchemaApiGetAllResponse,
  ICertificationSchemaApiGetAttrs,
  ICertificationSchemaApiGetResponse,
  ICertificationSchemaApiSaveAttrs,
  ICertificationSchemaApiSaveResponse,
} from 'interfaces/back-office/content-management/certification/schema/certification-schema-api.interface'
// eslint-disable-next-line
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class CertificationSchemaApi extends BaseApi<ICertificationSchemaApi> implements ICertificationSchemaApiRequest {
  readonly url = ApiConstant.CONTENT_CERTIFICATION_SCHEMA_URL
  private certificationSchemaUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get tuk list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationSchemaApiGetAllAttrs} payload
   *
   * @return {Promise<ICertificationSchemaApiGetAllResponse>} Promise<ICertificationSchemaApiGetAllResponse>
   */
  async certificationSchema_getCertificationSchemaList(
    payload: ICertificationSchemaApiGetAllAttrs,
  ): Promise<ICertificationSchemaApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.certificationSchemaUrl}/list`, '', { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get tuk
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationSchemaApiGetAttrs} payload
   *
   * @return {Promise<ICertificationSchemaApiGetResponse>} Promise<ICertificationSchemaApiGetResponse>
   */
  async certificationSchema_getCertificationSchema(
    payload: ICertificationSchemaApiGetAttrs,
  ): Promise<ICertificationSchemaApiGetResponse> {
    try {
      const response = await this.POST(`${this.certificationSchemaUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save tuk
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationSchemaApiSaveAttrs} payload
   *
   * @return {Promise<ICertificationSchemaApiSaveResponse>} Promise<ICertificationSchemaApiSaveResponse>
   */
  async certificationSchema_saveCertificationSchema(
    payload: ICertificationSchemaApiSaveAttrs,
  ): Promise<ICertificationSchemaApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: `${this.certificationSchemaUrl}/update/${payload.params.id}`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
